import filter from 'lodash/filter'
import {
  Fulfillment,
  FulfillmentItem,
  fulfillmentStatusTypes,
  fulfillmentTypes,
} from 'app/features/orders/models'
import ShippingPackage from '../../models/ShippingPackage'
import {CarrierFulfillment} from '../../models/Fulfillment'

export const mapToCreateFulfillmentInput = (model: any) => {
  const {order, fulfillAt, shippingDefinition, tracking} = model
  const items = filter(order.orderItems, (item: any) => item.fulfillmentQuantity > 0)
  const fulfillmentItems: FulfillmentItem[] = items.map((item: any) => ({
    orderItemId: item.id,
    quantity: item.fulfillmentQuantity,
    variantId: item.variantId,
    price: item.price,
  }))

  const fulfillment: Fulfillment = {
    orderId: order.id,
    status: fulfillmentStatusTypes.pending,
    fulfillmentType: fulfillmentTypes.shippingService,
    fulfillAt: fulfillAt,
    shippingDefinition,
    tracking,
    shippingPrice: shippingDefinition.deliveryMethod.rate,
    fulfillmentItems: {create: fulfillmentItems},
    locationId: order.fulfillmentLocationId,
  }
  return fulfillment
}

export const mapToCreateCarrierFulfillmentInput = (model: any) => {
  const {order, fulfillAt, shippingDefinition, tracking} = model
  const items = filter(order.orderItems, (item: any) => item.fulfillmentQuantity > 0)
  const fulfillmentItems: FulfillmentItem[] = items.map((item: any) => ({
    orderItemId: item.id,
    quantity: item.fulfillmentQuantity,
    variantId: item.variantId,
    price: item.price,
  }))

  const fulfillment: CarrierFulfillment = {
    orderId: order.id,
    status: fulfillmentStatusTypes.pending,
    fulfillmentType: fulfillmentTypes.shippingService,
    fulfillAt: fulfillAt,
    shippingDefinition,
    tracking,
    shippingPrice: shippingDefinition.deliveryMethod.rate,
    locationId: order.fulfillmentLocationId,
  }
  return {fulfillment, fulfillmentItems}
}

export const mapToShippingModel = (data: any) => {
  const shippingPackage: ShippingPackage = {
    id: data.id,
    name: data.name,
    dimension: {
      height: parseFloat(data.dimension.height),
      length: parseFloat(data.dimension.length),
      width: parseFloat(data.dimension.width),
      units: data.units,
    },
    weight: {
      value: parseFloat(data.weight.value),
      units: data.units,
    },
  }
  return shippingPackage
}

export const mapToUpdateShippingPackageModel = (shippingPackage: ShippingPackage, id: string) => {
  return {
    id,
    patch: shippingPackage,
  }
}
